import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledNewBadge = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'left',
  justifyContent: 'center',
  backgroundColor: '#00A36C',
  color: 'white',
  fontSize: '10px',
  fontWeight: 'bold',
  padding: '4px 22px 4px 7px',
  height: '20px',
  borderRadius: '4px 0 0 4px', // Rounded left corners
  position: 'relative',
  textTransform: 'uppercase',
  overflow: 'hidden', // Hide any overflow from the pseudo-element
  clipPath: 'polygon(0 0, calc(100% - 10px) 0, 60% 50%, calc(100% - 10px) 100%, 0 100%)', // Adjust the shape for inside cut

  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0, // Align to the right edge
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '10px 0 10px 10px', // top right bottom left
    borderColor: 'transparent transparent transparent #00A36C', // Left triangle pointing inwards
  },
}));

export default function NewBadge({ code }) {
  if (!code) {
    return null;
  }
  return <StyledNewBadge>NEW</StyledNewBadge>;
}
